// extracted by mini-css-extract-plugin
module.exports = {"benefitsHeadingDiv":"benefits-heading_benefitsHeadingDiv__1ZcrA"};